import React, { useState, useEffect } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const PortfolioPage: React.FC = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeFilter, setActiveFilter] = useState('all');
  const [, setSelectedProject] = useState<number | null>(null);

  const [headerRef, headerVisible] = useScrollAnimation(0.3);
  const [filterRef, filterVisible] = useScrollAnimation(0.2);
  const [projectsRef, projectsVisible] = useScrollAnimation(0.1);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const filters = [
    { id: 'all', label: 'All Projects', icon: '🌟' },
    { id: 'billboards', label: '3D Billboards', icon: '📺' },
    { id: 'activations', label: 'Brand Activations', icon: '🎯' },
    { id: 'digital', label: 'Digital Campaigns', icon: '💻' },
    { id: 'events', label: 'Events', icon: '🎪' }
  ];

  const projects = [
    {
      id: 1,
      title: "Aviation Brand Identity Suite",
      category: "digital",
      client: "Confidential Aviation Client",
      year: "2024",
      description: "Complete brand transformation including logo design, visual identity, and comprehensive brand guidelines for aviation industry client.",
      image: "/Brand aviation raw data/0017adba-ece5-4d9d-b1fa-2e1389c35016.jpg",
      tags: ["Brand Strategy", "Logo Design", "Visual Identity"],
      stats: { reach: "2.5M", engagement: "89%", conversion: "34%" },
      gallery: [
        "/Brand aviation raw data/0017adba-ece5-4d9d-b1fa-2e1389c35016.jpg",
        "/Brand aviation raw data/001f5dfb-5444-4e92-b803-7915e5ae007a.jpg",
        "/Brand aviation raw data/00d20109-9f82-4e1e-a9aa-d5d51d329952.jpg"
      ]
    },
    {
      id: 2,
      title: "3D Billboard Campaign Design",
      category: "billboards",
      client: "Aviation Marketing Agency",
      year: "2024",
      description: "Revolutionary 3D billboard design that creates immersive brand experiences and captures audience attention at airports.",
      image: "/Brand aviation raw data/001f5dfb-5444-4e92-b803-7915e5ae007a.jpg",
      tags: ["3D Design", "Outdoor Advertising", "Creative"],
      stats: { reach: "3.1M", engagement: "84%", conversion: "31%" },
      gallery: [
        "/Brand aviation raw data/001f5dfb-5444-4e92-b803-7915e5ae007a.jpg",
        "/Brand aviation raw data/00d20109-9f82-4e1e-a9aa-d5d51d329952.jpg",
        "/Brand aviation raw data/019c8aa8-4267-4512-86cd-02ffe6476656.jpg"
      ]
    },
    {
      id: 3,
      title: "Digital Marketing Campaign Suite",
      category: "digital",
      client: "Regional Airline",
      year: "2024",
      description: "Comprehensive digital marketing strategy including social media, SEO, and paid advertising campaigns.",
      image: "/Brand aviation raw data/0f49e5b9-0d3f-4c0a-a9f2-ace36fcd99a2.jpg",
      tags: ["Digital Marketing", "Social Media", "SEO"],
      stats: { reach: "5.2M", engagement: "76%", conversion: "42%" },
      gallery: [
        "/Brand aviation raw data/0f49e5b9-0d3f-4c0a-a9f2-ace36fcd99a2.jpg",
        "/Brand aviation raw data/11910877-17ba-4bcc-a531-9cab69b1cb2b.jpg",
        "/Brand aviation raw data/1208949e-1eaf-49a7-a167-7a1053f54feb.jpg"
      ]
    },
    {
      id: 4,
      title: "Event Marketing Activation",
      category: "events",
      client: "Aviation Technology Company",
      year: "2024",
      description: "Interactive event marketing activation at major aviation trade shows with immersive brand experiences.",
      image: "/Brand aviation raw data/9d39466e-acd8-4392-8840-bd4392cfd233.jpg",
      tags: ["Event Marketing", "Trade Shows", "Interactive"],
      stats: { reach: "150K", engagement: "95%", conversion: "67%" },
      gallery: [
        "/Brand aviation raw data/9d39466e-acd8-4392-8840-bd4392cfd233.jpg",
        "/Brand aviation raw data/122680c5-d984-4bce-b675-ee4b6fc64a9b.jpg",
        "/Brand aviation raw data/1276e597-986f-46e0-a0f3-21cfd4bc88da.jpg"
      ]
    },
    {
      id: 5,
      title: "ATL Television Commercial",
      category: "billboards",
      client: "Premium Airline",
      year: "2024",
      description: "High-impact television commercial production featuring aviation themes and premium brand positioning.",
      image: "/Brand aviation raw data/38ef9123-c6f0-4f4e-ade3-4d9166436827.jpg",
      tags: ["TV Commercials", "Video Production", "Brand Positioning"],
      stats: { reach: "4.7M", engagement: "88%", conversion: "39%" },
      gallery: [
        "/Brand aviation raw data/38ef9123-c6f0-4f4e-ade3-4d9166436827.jpg",
        "/Brand aviation raw data/14b691bc-2748-4111-b720-1935de952dad.jpg",
        "/Brand aviation raw data/154a3724-957b-4e10-a17a-bf23c3c5bac7.jpg"
      ]
    },
    {
      id: 6,
      title: "Print Advertising Campaign",
      category: "digital",
      client: "Commercial Aviation Company",
      year: "2024",
      description: "Premium print advertising campaign for aviation magazines and industry publications.",
      image: "/Brand aviation raw data/84a5f4c7-920d-453d-bf31-e7df669161b1.jpg",
      tags: ["Print Advertising", "Magazine Ads", "Brand Awareness"],
      stats: { reach: "1.8M", engagement: "92%", conversion: "28%" },
      gallery: [
        "/Brand aviation raw data/84a5f4c7-920d-453d-bf31-e7df669161b1.jpg",
        "/Brand aviation raw data/16ab2c0a-65ae-47cf-bd31-221d03ba4e03.jpg",
        "/Brand aviation raw data/1da57f47-64ac-41a4-991b-503aa5a67643.jpg"
      ]
    },
    {
      id: 7,
      title: "Interactive Display Design",
      category: "activations",
      client: "Airport Authority",
      year: "2024",
      description: "Interactive digital display design for airport terminals featuring cutting-edge technology and user engagement.",
      image: "/Brand aviation raw data/4637d1a2-111e-47d6-aac7-0025cb84d460.jpg",
      tags: ["Interactive Design", "Digital Displays", "User Experience"],
      stats: { reach: "2.1M", engagement: "85%", conversion: "45%" },
      gallery: [
        "/Brand aviation raw data/4637d1a2-111e-47d6-aac7-0025cb84d460.jpg",
        "/Brand aviation raw data/1e521e20-ccb0-4375-8783-590366dea967.jpg",
        "/Brand aviation raw data/20bb0e0f-a440-42a5-8474-e97b0dc805e2.jpg"
      ]
    },
    {
      id: 8,
      title: "Brand Video Production",
      category: "events",
      client: "Aviation Services Company",
      year: "2024",
      description: "Professional brand video showcasing aviation services with cinematic quality and compelling storytelling.",
      image: "/Brand aviation raw data/32182631-2bab-4531-8b56-751f122e6b96.jpg",
      tags: ["Video Production", "Brand Storytelling", "Cinematic"],
      stats: { reach: "3.5M", engagement: "78%", conversion: "52%" },
      gallery: [
        "/Brand aviation raw data/32182631-2bab-4531-8b56-751f122e6b96.jpg",
        "/Brand aviation raw data/a1a535db-ef06-444d-bf8a-14273812b519",
        "/Brand aviation raw data/a41bfb0a-84de-4d62-bee0-24301385d6fc"
      ]
    },
    {
      id: 9,
      title: "Marketing Collateral Suite",
      category: "digital",
      client: "Aviation Training Academy",
      year: "2024",
      description: "Comprehensive marketing collateral including brochures, flyers, and promotional materials for aviation client.",
      image: "/Brand aviation raw data/af1c54dc-e463-48b4-97c6-b2e3ab20ea0e",
      tags: ["Marketing Collateral", "Print Design", "Brand Consistency"],
      stats: { reach: "1.2M", engagement: "91%", conversion: "38%" },
      gallery: [
        "/Brand aviation raw data/af1c54dc-e463-48b4-97c6-b2e3ab20ea0e",
        "/Brand aviation raw data/b1379f06-3f99-4929-989a-0eaee4275739",
        "/Brand aviation raw data/ba57ded0-2fa4-4ebb-9a3d-66d425089a09"
      ]
    },
    {
      id: 10,
      title: "Aviation Safety Campaign",
      category: "activations",
      client: "Safety First Aviation",
      year: "2024",
      description: "Strategic safety awareness campaign featuring interactive displays and educational materials for aviation professionals.",
      image: "/Brand aviation raw data/c03aa4bf-d933-4698-966e-1404e702eac0",
      tags: ["Safety Campaign", "Educational", "Interactive"],
      stats: { reach: "2.8M", engagement: "87%", conversion: "41%" },
      gallery: [
        "/Brand aviation raw data/c03aa4bf-d933-4698-966e-1404e702eac0",
        "/Brand aviation raw data/d1bba38e-09f9-47eb-aa0d-d3d83cc72796",
        "/Brand aviation raw data/d14bf54b-6514-440d-8e95-badb4edf33c5"
      ]
    },
    {
      id: 11,
      title: "Airport Terminal Experience",
      category: "events",
      client: "Innovation Labs",
      year: "2024",
      description: "Interactive digital experiences showcasing aviation technology and innovation in airport terminals.",
      image: "/Brand aviation raw data/d7494945-8943-4a04-860e-cac38e26d869",
      tags: ["Digital Experience", "Innovation", "Airport Technology"],
      stats: { reach: "3.2M", engagement: "82%", conversion: "46%" },
      gallery: [
        "/Brand aviation raw data/d7494945-8943-4a04-860e-cac38e26d869",
        "/Brand aviation raw data/dc86895f-1885-46db-83ac-8c40b6d46212",
        "/Brand aviation raw data/e509e2c3-9292-4cf6-b29c-1f6bfd78597c"
      ]
    },
    {
      id: 12,
      title: "Aviation Technology Summit",
      category: "events",
      client: "TechAviation",
      year: "2024",
      description: "Full-scale conference management for the aviation technology summit, including stage fabrication and brand integration.",
      image: "/Brand aviation raw data/f86f5a6a-17b3-466d-8cd2-288911352bfd",
      tags: ["Conference Management", "B2B Marketing", "Technology"],
      stats: { reach: "180K", engagement: "96%", conversion: "72%" },
      gallery: [
        "/Brand aviation raw data/f86f5a6a-17b3-466d-8cd2-288911352bfd",
        "/Brand aviation raw data/IMG_1051.JPG",
        "/Brand aviation raw data/IMG_1052.JPG"
      ]
    },
    {
      id: 13,
      title: "Flight Simulator Experience",
      category: "activations",
      client: "SimFlight Pro",
      year: "2024",
      description: "Immersive flight simulator experiences with cutting-edge VR technology for pilot training and entertainment.",
      image: "/Brand aviation raw data/IMG_1053.JPG",
      tags: ["VR Technology", "Flight Training", "Immersive Experience"],
      stats: { reach: "1.5M", engagement: "93%", conversion: "58%" },
      gallery: [
        "/Brand aviation raw data/IMG_1053.JPG",
        "/Brand aviation raw data/IMG_1054.JPG",
        "/Brand aviation raw data/IMG_1055.JPG"
      ]
    },
    {
      id: 14,
      title: "Aviation Museum Launch",
      category: "events",
      client: "Aviation Heritage",
      year: "2024",
      description: "Grand opening activation for the new aviation museum featuring interactive exhibits and historical aircraft displays.",
      image: "/Brand aviation raw data/IMG_1056.JPG",
      tags: ["Museum Launch", "Historical Display", "Interactive Exhibits"],
      stats: { reach: "850K", engagement: "89%", conversion: "35%" },
      gallery: [
        "/Brand aviation raw data/IMG_1056.JPG",
        "/Brand aviation raw data/IMG_1057.JPG",
        "/Brand aviation raw data/IMG_1058.JPG"
      ]
    },
    {
      id: 15,
      title: "Airlines Partnership Campaign",
      category: "digital",
      client: "Global Airlines",
      year: "2024",
      description: "Strategic partnership campaign between major airlines featuring joint marketing initiatives and customer engagement programs.",
      image: "/Brand aviation raw data/IMG_2740.JPG",
      tags: ["Partnership Campaign", "Joint Marketing", "Customer Engagement"],
      stats: { reach: "4.1M", engagement: "79%", conversion: "43%" },
      gallery: [
        "/Brand aviation raw data/IMG_2740.JPG",
        "/Brand aviation raw data/IMG_2743.JPG",
        "/Brand aviation raw data/2178479a-16a3-45e7-9a6c-fddd7b6617fe.jpg"
      ]
    },
    {
      id: 16,
      title: "Airport Security Awareness",
      category: "activations",
      client: "Security Solutions",
      year: "2024",
      description: "Comprehensive security awareness campaign featuring interactive displays and educational materials for airport visitors.",
      image: "/Brand aviation raw data/a601302d-02e7-41cc-9d34-a9ba6250ef76",
      tags: ["Security Awareness", "Educational Campaign", "Airport Safety"],
      stats: { reach: "2.3M", engagement: "85%", conversion: "39%" },
      gallery: [
        "/Brand aviation raw data/a601302d-02e7-41cc-9d34-a9ba6250ef76",
        "/Brand aviation raw data/IMG_4291.mp4",
        "/Brand aviation raw data/fire work.mp4"
      ]
    }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  return (
    <section className="relative min-h-screen py-20 bg-gradient-to-br from-slate-900 via-orange-900 to-slate-900">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-r from-orange-600/5 via-red-600/5 to-yellow-600/5"></div>
        <div className="absolute top-20 left-20 w-32 h-32 bg-orange-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-40 h-40 bg-white/5 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div 
          ref={headerRef}
          className={`text-center mb-16 transition-all duration-1000 ${
            headerVisible 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-10'
          }`}
        >
          <div className={`inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 text-white text-sm font-medium mb-6 transition-all duration-1000 ${
            isLoaded ? 'animate-fade-in-up' : ''
          }`} style={{ animationDelay: '0.1s' }}>
            <div className="w-2 h-2 bg-orange-400 rounded-full animate-pulse"></div>
            <span>Our Portfolio</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 transition-all duration-700">
            <span className={`block transition-all duration-500 ${
              isLoaded ? 'animate-fade-in-up' : ''
            }`} style={{ animationDelay: '0.2s' }}>
              Our Work
            </span>
            <span className={`block bg-gradient-to-r from-orange-400 to-yellow-400 bg-clip-text text-transparent transition-all duration-500 ${
              isLoaded ? 'animate-fade-in-up' : ''
            }`} style={{ animationDelay: '0.4s' }}>
              Speaks Volumes
            </span>
          </h1>
          
          <div className={`w-24 h-1 bg-gradient-to-r from-orange-400 to-yellow-400 mx-auto mb-6 transition-all duration-500 ${
            isLoaded ? 'animate-fade-in-up' : ''
          }`} style={{ animationDelay: '0.6s' }}></div>
          
          <p className={`text-lg sm:text-xl lg:text-2xl text-white/90 max-w-4xl mx-auto leading-relaxed transition-all duration-500 ${
            isLoaded ? 'animate-fade-in-up' : ''
          }`} style={{ animationDelay: '0.8s' }}>
            Explore our award-winning campaigns that have transformed aviation brands and created memorable experiences for millions of passengers worldwide.
          </p>
        </div>

        {/* Filter Buttons */}
        <div 
          ref={filterRef}
          className={`flex flex-wrap justify-center gap-4 mb-16 transition-all duration-1000 ${
            filterVisible 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-10'
          }`}
        >
          {filters.map((filter, index) => (
            <button
              key={filter.id}
              onClick={() => setActiveFilter(filter.id)}
              className={`group relative px-6 py-3 rounded-full font-semibold transition-all duration-300 hover:scale-105 ${
                activeFilter === filter.id
                  ? 'bg-gradient-to-r from-orange-600 to-yellow-600 text-white shadow-lg shadow-orange-500/25'
                  : 'bg-white/10 backdrop-blur-sm border border-white/20 text-white hover:bg-white/20 hover:border-orange-400/50'
              }`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <span className="flex items-center space-x-2">
                <span className="text-lg">{filter.icon}</span>
                <span>{filter.label}</span>
              </span>
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div 
          ref={projectsRef}
          className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 ${
            projectsVisible 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-10'
          }`}
        >
          {filteredProjects.map((project, index) => (
            <div
              key={project.id}
              className="group relative bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl overflow-hidden hover:bg-white/15 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-orange-500/20"
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => setSelectedProject(project.id)}
            >
              {/* Project Image */}
              <div className="relative h-64 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-orange-500/20 to-yellow-500/20"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-6xl opacity-50">
                    {project.category === 'billboards' && '📺'}
                    {project.category === 'activations' && '🎯'}
                    {project.category === 'digital' && '💻'}
                    {project.category === 'events' && '🎪'}
                  </div>
                </div>
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <button className="bg-white/20 backdrop-blur-sm border border-white/30 rounded-full p-3 text-white hover:bg-white/30 transition-all duration-300">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Project Content */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-orange-400 text-sm font-semibold">{project.client}</span>
                  <span className="text-white/60 text-sm">{project.year}</span>
                </div>
                
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-orange-400 transition-colors duration-300">
                  {project.title}
                </h3>
                
                <p className="text-gray-300 text-sm mb-4 leading-relaxed">
                  {project.description}
                </p>
                
                {/* Tags */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.tags.map((tag, tagIndex) => (
                    <span
                      key={tagIndex}
                      className="px-3 py-1 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-xs text-white"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                
                {/* Stats */}
                <div className="grid grid-cols-3 gap-4 pt-4 border-t border-white/10">
                  <div className="text-center">
                    <div className="text-orange-400 font-bold text-lg">{project.stats.reach}</div>
                    <div className="text-white/60 text-xs">Reach</div>
                  </div>
                  <div className="text-center">
                    <div className="text-orange-400 font-bold text-lg">{project.stats.engagement}</div>
                    <div className="text-white/60 text-xs">Engagement</div>
                  </div>
                  <div className="text-center">
                    <div className="text-orange-400 font-bold text-lg">{project.stats.conversion}</div>
                    <div className="text-white/60 text-xs">Conversion</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center mt-20">
          <div className="bg-gradient-to-r from-orange-600/20 to-yellow-600/20 backdrop-blur-sm border border-white/20 rounded-2xl p-8 lg:p-12">
            <h3 className="text-3xl font-bold text-white mb-4">Ready to Create Something Amazing?</h3>
            <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
              Let's discuss your next campaign and make your brand soar higher than ever before.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => window.location.href = '/quote'}
                className="bg-gradient-to-r from-orange-600 to-yellow-600 text-white px-8 py-4 rounded-xl font-semibold hover:shadow-lg hover:shadow-orange-500/25 transition-all duration-300 hover:scale-105"
              >
                Start Your Project
              </button>
              <button 
                onClick={() => window.location.href = '/'}
                className="border border-white/30 text-white px-8 py-4 rounded-xl font-semibold hover:bg-white/10 hover:border-orange-400/50 transition-all duration-300"
              >
                Back to Home
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS */}
      <style>{`
        @keyframes fade-in-up {
          from { 
            opacity: 0; 
            transform: translateY(20px); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
          }
        }
        
        .animate-fade-in-up { 
          animation: fade-in-up 0.6s ease-out forwards; 
        }
      `}</style>
    </section>
  );
};

export default PortfolioPage;
